<template lang="pug">
    v-dialog(v-if="errorsList" v-model="showErrorsDialog" full-width)
        v-card.pa-3.ma-5.errorsWrapper
            title-component(title="Errors List")

            div.closeButton
                v-btn(
                    icon
                    dark
                    small
                    @click="closeDialog"
                    class="closeIcon"
                )
                    v-icon(size="16") close

            v-data-table.c-table(
                :headers-length="2"
                :items="errorsList"
                :headers="headers"
                hide-actions
            )
                template(
                    v-slot:items="props"
                )
                    tr

                        // User Full Name
                        td {{ props.item.key }}

                        // User Email
                        td {{ props.item.error }}
</template>

<script>
    import { mapFields } from 'vuex-map-fields';
    import { mapGetters } from 'vuex';
    import Title from '~components/Title';

    export default {
        components: {
            TitleComponent: Title
        },
        data() {
            return {
                headers: [
                    { text: 'Row Number', value: 'key', sortable: false },
                    { text: '', value: 'error', sortable: false }
                ]
            };
        },
        computed: {
            ...mapFields('document', {
                showErrorsDialog: 'showErrorsDialog'
            }),
            ...mapGetters('document', ['errorsList'])
        },
        methods: {
            closeDialog() {
                this.showErrorsDialog = false;
            }
        }
    };
</script>

<style lang="stylus" scoped>
    @import "../../../../assets/style/_variables.styl"

    .errorsWrapper
        background-color: $theme.primary
        position: relative

    .closeButton
        position: absolute
        right: 16px
        top: 16px
</style>
